function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M191.3 0H92.1v283.5h99.2V0zM163 255.1h-42.6v-17h21.3v-14.2h-21.3v-28.3h21.3v-14.2h-21.3V153h21.3v-14.2h-21.3v-28.1h21.3V96.4h-21.3V68.1h21.3V53.9h-21.3V28.3H163v226.8z"
})));